import axios from "axios"

const BASE_URL = "https://admin-wp.halftimepizzaboston.com/wp-json"

export const contactFormApi = axios.create({
  baseURL: `${BASE_URL}/contact-form-7/v1/contact-forms`,
})

export const mediaApi = axios.create({
  baseURL: `${BASE_URL}`,
})
